<template>
  <div>
    <h3 class="text-center" style="text-transform: uppercase">
      Hóa đơn tiền phòng
    </h3>
    <table class="mx-auto">
      <tr style="height: 38px">
        <td
          colspan="2"
          class="text-left text-no-wrap font-weight-bold"
          style="width: 200px"
        >
          Tháng {{ bill.month | toLocaleMonth }}
        </td>
      </tr>
      <tr>
        <td
          class="text-left text-no-wrap font-weight-bold"
          style="width: 200px;"
        >
          {{ bill.name }}
        </td>
        <td
          class="text-right text-no-wrap font-weight-bold"
          style="width: 200px"
        >
          {{ bill.room_id }}
        </td>
      </tr>
      <tr>
        <td class="font-weight-bold">Số ngày</td>
        <td class="text-right">{{ bill.date_count | formatNumber }}</td>
      </tr>
      <tr>
        <td class="font-weight-bold">Tiền phòng {{roomTerm}}</td>
        <td class="text-right">
          {{ bill.room_bill | formatNumber }}
        </td>
      </tr>

      <tr>
        <td class="font-weight-bold" colspan="2">Tiền dịch vụ ({{ serviceTermStartDate }} - {{ serviceTermEndDate }})</td>
      </tr>
      <tr>
        <td class="text-left text-no-wrap" style="width: 300px">
          -- Tiền rác và vệ sinh 
        </td>
        <td class="text-right text-no-wrap">
          {{ bill.trash_bill | formatNumber }}
        </td>
      </tr>
      <tr>
        <td class="text-left text-no-wrap">
          -- Tiền Internet
        </td>
        <td class="text-right text-no-wrap">
          {{ bill.internet.total_bill | formatNumber }}
        </td>
      </tr>
      <tr>
        <td class="text-left text-no-wrap">
          -- Tiền xe
        </td>
        <td class="text-right text-no-wrap">
          {{
            (bill.motorbike.total_bill + bill.bike.total_bill) | formatNumber
          }}
        </td>
      </tr>
      <tr>
        <td class="text-left text-no-wrap">
          -- Tiền máy giặt
        </td>
        <td class="text-right text-no-wrap">
          {{ bill.washing_machine.total_bill | formatNumber }}
        </td>
      </tr>
      <tr>
        <td class="text-left text-no-wrap">
          -- Tiền máy lạnh
        </td>
        <td class="text-right text-no-wrap">
          {{ bill.air_conditioner.total_bill | formatNumber }}
        </td>
      </tr>
      <tr class="font-weight-bold">
        <td class="text-left text-no-wrap">Thành tiền</td>
        <td class="text-right text-no-wrap">
          {{ (bill.trash_bill + bill.internet.total_bill + bill.motorbike.total_bill + bill.bike.total_bill + bill.washing_machine.total_bill + bill.air_conditioner.total_bill) | formatNumber }}
        </td>
      </tr>
      
      <tr>
        <td class="font-weight-bold" colspan="2">Tiền điện</td>
      </tr>
      <tr>
        <td class="text-left text-no-wrap">Đơn giá</td>
        <td class="text-right text-no-wrap">
          {{ bill.electric_price | formatNumber }}
        </td>
      </tr>
      <tr>
        <td class="text-left text-no-wrap">-- Đầu kỳ ({{ electricTermStartDate }})</td>
        <td class="text-right text-no-wrap" v-if="bill.electric_meter_change">
          {{ bill.electric.start }} / {{ bill.electric_meter_change.new_meter_number | formatNumber }}
        </td>
        <td class="text-right text-no-wrap" v-else>
          {{ bill.electric.start | formatNumber }}
        </td>
      </tr>
      <tr>
        <td class="text-left text-no-wrap">-- Cuối kỳ ({{ electricTermEndDate}})</td>
        <td class="text-right text-no-wrap" v-if="bill.electric_meter_change">
          {{ bill.electric_meter_change.old_meter_number }} / {{ bill.electric.end | formatNumber }}
        </td>
        <td class="text-right text-no-wrap" v-else>
          {{ bill.electric.end | formatNumber }}
        </td>
      </tr>
      <tr>
        <td class="text-left text-no-wrap">-- Tiêu thụ</td>
        <td class="text-right text-no-wrap" v-if="bill.electric_meter_change">
          {{ (bill.electric.end - bill.electric_meter_change.new_meter_number + bill.electric_meter_change.old_meter_number - bill.electric.start) | formatNumber }}
        </td>
        <td class="text-right text-no-wrap" v-else>
          {{ (bill.electric.end - bill.electric.start) | formatNumber }}
        </td>
      </tr>
      <tr class="font-weight-bold">
        <td class="text-left text-no-wrap">Thành tiền</td>
        <td class="text-right text-no-wrap">
          {{ bill.electric.total_bill | formatNumber }}
        </td>
      </tr>
      <tr>
        <td class="font-weight-bold" colspan="2">
          Tiền nước
        </td>
      </tr>
      <tr>
        <td class="text-left text-no-wrap">Đơn giá</td>
        <td class="text-right text-no-wrap">
          {{ bill.water_price | formatNumber }}
        </td>
      </tr>
      <tr>
        <td class="text-left text-no-wrap">-- Đầu kỳ ({{ waterTermStartDate }})</td>
        <td class="text-right text-no-wrap" v-if="bill.water_meter_change">
          {{ bill.water.start }} / {{ bill.water_meter_change.new_meter_number | formatNumber }}
        </td>
        <td class="text-right text-no-wrap" v-else>
          {{ bill.water.start | formatNumber }}
        </td>
      </tr>
      <tr>
        <td class="text-left text-no-wrap">-- Cuối kỳ ({{ waterTermEndDate }})</td>
        <td class="text-right text-no-wrap" v-if="bill.water_meter_change">
          {{ bill.water_meter_change.old_meter_number }} / {{ bill.water.end | formatNumber }}
        </td>
        <td class="text-right text-no-wrap" v-else>
          {{ bill.water.end | formatNumber }}
        </td>
      </tr>
      <tr>
        <td class="text-left text-no-wrap">-- Tiêu thụ</td>
        <td class="text-right text-no-wrap" v-if="bill.water_meter_change">
          {{ (bill.water.end - bill.water_meter_change.new_meter_number + bill.water_meter_change.old_meter_number - bill.water.start) | formatNumber }}
        </td>
        <td class="text-right text-no-wrap" v-else>
          {{ (bill.water.end - bill.water.start) | formatNumber }}
        </td>
      </tr>
      <tr class="font-weight-bold">
        <td class="text-left text-no-wrap">Thành tiền</td>
        <td class="text-right text-no-wrap">
          {{ bill.water.total_bill | formatNumber }}
        </td>
      </tr>
      
      <tr>
        <td colspan="2">
          <hr />
        </td>
      </tr>
      <tr class="font-weight-bold">
        <td class="text-left">TỔNG CỘNG</td>
        <td class="text-right">
          {{ bill.total_bill | formatNumber }}
        </td>
      </tr>
      <tr class="font-weight-bold">
        <td class="text-left">Số tiền nộp thiếu/dư tháng trước</td>
        <td class="text-right">
          {{ previousMonthDebt | formatNumber }}
        </td>
      </tr>
      <tr class="font-weight-bold">
        <td class="text-left">TỔNG CỘNG SỐ TIỀN PHẢI NỘP</td>
        <td class="text-right">
          {{ totalBillWithDebt | formatNumber }}
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <hr />
        </td>
      </tr>
      <tr style="height: 38px">
        <td class="font-weight-bold" colspan="2">
          Gọi 0835990179 gặp Hương để phản ánh
        </td>
      </tr>
    </table>

    <!-- <table class="mx-auto">
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Số phòng</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.room_id }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Thời gian</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.month }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Họ tên</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.name }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Số người ở</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.customers.length }} người</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Ngày hẹn vào ở</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.date_schedule_in | formatTimeServer }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Ngày vào ở</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.date_in | formatTimeServer }}</td>
        </tr>
        <tr></tr>
        <tr></tr>
        <tr class="font-weight-black">
            <td class="text-left">TỔNG CỘNG</td>
            <td class="text-right">{{ bill.total_bill | formatNumber}} VND</td>
        </tr>
        <tr v-if="bill.csv_data">
            <td class="text-left">Excel</td>
            <td class="text-right">{{ bill.csv_data.total_bill | formatNumber}} VND</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                <hr>
                <u>Tiền điện</u>
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">Đơn giá</td>
            <td class="text-right text-no-wrap">{{ bill.electric_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Đầu kỳ</td>
            <td class="text-right text-no-wrap">{{ bill.electric.start | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Cuối kỳ</td>
            <td class="text-right text-no-wrap">{{ bill.electric.end | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Tiêu thụ</td>
            <td class="text-right text-no-wrap">{{ (bill.electric.end - bill.electric.start) | formatNumber }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.electric.total_bill | formatNumber }}</td>
        </tr>
        <tr v-if="bill.csv_data">
            <td class="text-left text-no-wrap">Excel</td>
            <td class="text-right text-no-wrap">{{ bill.csv_data.electric_total_bill | formatNumber }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                <hr>
                <u>Tiền nước</u>
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">Đơn giá</td>
            <td class="text-right text-no-wrap">{{ bill.water_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Đầu kỳ</td>
            <td class="text-right text-no-wrap">{{ bill.water.start | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Cuối kỳ</td>
            <td class="text-right text-no-wrap">{{ bill.water.end | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Tiêu thụ</td>
            <td class="text-right text-no-wrap">{{ (bill.water.end - bill.water.start) | formatNumber }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.water.total_bill | formatNumber }}</td>
        </tr>
        <tr v-if="bill.csv_data">
            <td class="text-left text-no-wrap">Excel</td>
            <td class="text-right text-no-wrap">{{ bill.csv_data.water_total_bill | formatNumber }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                <hr>
                <u>Tiền phòng</u>
            </td>
        </tr>
        <tr>
            <td class="text-left">Đơn giá</td>
            <td class="text-right">{{ bill.room_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left">-- Số ngày</td>
            <td class="text-right">{{ bill.date_count | formatNumber }} {{ bill.csv_data ? '(' + bill.csv_data.date_count + ')' : '' }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.room_bill | formatNumber }} {{ bill.csv_data ? '(' + formatNumber(bill.csv_data.room_bill)  + ')' : '' }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                <hr>
                <u>Tiền rác và vệ sinh</u>
            </td>
        </tr>
        <tr>
            <td class="text-left">Đơn giá</td>
            <td class="text-right">{{ bill.trash_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left">-- Số ngày</td>
            <td class="text-right">{{ bill.service_date_count | formatNumber }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.trash_bill | formatNumber }} {{ bill.csv_data ? '(' + formatNumber(bill.csv_data.trash_total_bill) + ')' : '' }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                <hr>
                <u>Tiền xe</u>
            </td>
        </tr>
        <tr>
            <td class="text-left">Đơn giá xe máy</td>
            <td class="text-right">{{ bill.motorbike_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left">Đơn giá xe đạp</td>
            <td class="text-right">{{ bill.bike_price | formatNumber }}</td>
        </tr>
        <tr
            v-for="(device, index) in bill.motorbike.data"
            :key="index"
        >
            <td class="text-left">-- {{ device.name }}</td>
            <td class="text-right">{{ device.date_count }} ngày</td>
        </tr>
        <tr
            v-for="(device, index) in bill.bike.data"
            :key="index"
        >
            <td class="text-left">-- {{ device.name + (index + 1) }}</td>
            <td class="text-right">{{ device.date_count }} ngày</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.motorbike.total_bill + bill.bike.total_bill | formatNumber }} {{ bill.csv_data ? '(' + formatNumber(bill.csv_data.bike_motorbike_total_bill) + ')' : '' }}</td>
        </tr>
        <template v-if="bill.washing_machine && bill.washing_machine.total_bill">
            <tr>
                <td class="font-weight-bold" colspan="2">
                    <hr>
                    <u>Tiền máy giặt</u>
                </td>
            </tr>
            <tr>
                <td class="text-left">Đơn giá</td>
                <td class="text-right">{{ bill.washing_machine_price | formatNumber }}</td>
            </tr>
            <tr class="font-weight-bold">
                <td class="text-left text-no-wrap">Thành tiền</td>
                <td class="text-right text-no-wrap">{{ bill.washing_machine.total_bill | formatNumber }} {{ bill.csv_data ? '(' + formatNumber(bill.csv_data.washing_machine_total_bill) + ')' : '' }}</td>
            </tr>
        </template>
        <template v-if="bill.air_conditioner && bill.air_conditioner.total_bill">
            <tr>
                <td class="font-weight-bold" colspan="2">
                    <hr>
                    <u>Tiền máy lạnh</u>
                </td>
            </tr>
            <tr>
                <td class="text-left">Đơn giá</td>
                <td class="text-right">{{ bill.air_conditioner_price | formatNumber }}</td>
            </tr>
            <tr>
                <td class="text-left">Số ngày</td>
                <td class="text-right">{{ bill.air_conditioner.data[0].date_count }}</td>
            </tr>
            <tr class="font-weight-bold">
                <td class="text-left text-no-wrap">Thành tiền</td>
                <td class="text-right text-no-wrap">{{ bill.air_conditioner.total_bill | formatNumber }}</td>
            </tr>
        </template>
        <template v-if="bill.internet && bill.internet.total_bill">
            <tr>
                <td class="font-weight-bold" colspan="2">
                    <hr>
                    <u>Tiền Internet</u>
                </td>
            </tr>
            <tr
                v-for="(device, index) in bill.internet.data"
                :key="index"
            >
                <td class="text-left">-- {{ device.name }} ({{ device.price / 1000}}k)</td>
                <td class="text-right">{{ device.date_count }} ngày</td>
            </tr>
            <tr class="font-weight-bold">
                <td class="text-left text-no-wrap">Thành tiền</td>
                <td class="text-right text-no-wrap">{{ bill.internet.total_bill | formatNumber }} {{ bill.csv_data ? '(' + formatNumber(bill.csv_data.internet_total_bill) + ')' : '' }}</td>
            </tr>
        </template>
        <tr>
            <td colspan="2">BIDV (Nguyen Thi Gam): 31210000374258</td>
        </tr>
        <tr>
            <td colspan="2">VCB (Nguyen Thi Gam): 0181003531061</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">Gọi 0835990179 gặp Hương để phản ánh</td>
        </tr>
    </table> -->
  </div>
</template>
<script>
import moment from "moment";
import { handleDateCount } from '../../functions'

export default {
  props: {
    bill: Object,
    previous_month_bill: Object,
  },
  name: "room-bill-detail",
  data() {
    console.log("🚀 ~ bill:", this.bill)

    return {};
  },
  computed: {
    nextMonth() {
      const firstDateOfInputMonth = new Date(this.$props.bill.month + "-01");
      const firstDateOfNextMonth = moment(firstDateOfInputMonth)
        .add(1, "months")
        .toISOString();

      return new Date(firstDateOfNextMonth)
        .toLocaleDateString("en-GB")
        .substr(3);
    },
    firstDateOfLastMonth() {
      const firstDateOfInputMonth = new Date(this.$props.bill.month + "-01");
      const firstDateOfLastMonth = moment(firstDateOfInputMonth)
        .subtract(1, "months")
        .toISOString();

      return new Date(firstDateOfLastMonth);
    },
    electricTermStartDate() {
      const electricTermStartDate = new Date(this.$props.bill.month + "-01");

      return new Date(electricTermStartDate)
        .toLocaleDateString("en-GB")
        .substr(0, 5);
    },
    electricTermEndDate() {
      const firstDateOfInputMonth = new Date(this.$props.bill.month + "-01");
      const lastDateOfInputMonth = moment(firstDateOfInputMonth)
        .add(1, "months")
        .subtract(1, 'day')
        .toISOString();
      const electricTermEndDate = new Date(lastDateOfInputMonth).toLocaleDateString("en-GB").substr(0, 5);
      return electricTermEndDate;
    },
    waterTermStartDate() {
      const waterTermStartDate = new Date(this.firstDateOfLastMonth);
      if (this.$props.bill.month === '2025-03') {
        waterTermStartDate.setDate(5);
      } else {
        waterTermStartDate.setDate(12);
      }
      return waterTermStartDate.toLocaleDateString("en-GB").substr(0, 5);
    },
    waterTermEndDate() {
      const waterTermEndDate = new Date(this.$props.bill.month + "-11").toLocaleDateString("en-GB").substr(0, 5);
      return waterTermEndDate;
    },
    serviceTermStartDate() {
      if (this.bill.date_count < 30) {
        const serviceTermStartDate = new Date(this.bill.date_in);

        return new Date(serviceTermStartDate)
          .toLocaleDateString("en-GB")
          .substr(0, 5);
      } else {
        const serviceTermStartDate = new Date(this.$props.bill.month + "-01");

        return new Date(serviceTermStartDate)
          .toLocaleDateString("en-GB")
          .substr(0, 5);
      }
    },
    serviceTermEndDate() {
      const firstDateOfInputMonth = new Date(this.$props.bill.month + "-01");
      const lastDateOfInputMonth = moment(firstDateOfInputMonth)
        .add(1, "months")
        .subtract(1, 'day')
        .toISOString();
      const electricTermEndDate = new Date(lastDateOfInputMonth).toLocaleDateString("en-GB").substr(0, 5);
      return electricTermEndDate;
    },
    roomTerm() {
      const firstDateOfInputMonth = new Date(this.$props.bill.month + "-01");
      const lastDateOfInputMonth = moment(firstDateOfInputMonth)
        .add(1, "months")
        .subtract(1, 'day')
        .toDate();
      
      // Use date_out if available, otherwise calculate from date_in + date_count
      let stayEndDate;
      let staysUntilEndOfMonth = false;

      // Check if stay ends at or after the end of the billing month
      if (this.bill.date_out) {
        stayEndDate = new Date(this.bill.date_out);
        staysUntilEndOfMonth = moment(stayEndDate).isSame(lastDateOfInputMonth, 'day') || 
        moment(stayEndDate).isAfter(lastDateOfInputMonth, 'day');
      } else {
        // Recalculate dateCount and compare
        const recalculatedDateCount = handleDateCount({
          date_start: this.bill.date_in,
          chosen_month: this.bill.month,
          date_end: lastDateOfInputMonth,
        });
        staysUntilEndOfMonth = recalculatedDateCount === this.bill.date_count;
      }

      if (staysUntilEndOfMonth) {
        // Show next month format
        return `(tháng ${this.nextMonth})`;
      } else {
        // Show date range format using serviceTermStartDate and serviceTermEndDate
        return `(${this.serviceTermStartDate} - ${this.serviceTermEndDate})`;
      }
    },
    previousMonthDebt() {
      if (!this.previous_month_bill) return 0;

      return this.previous_month_bill.total_bill - this.previous_month_bill.collected_amount;
    },
    totalBillWithDebt() {
      return this.bill.total_bill + this.previousMonthDebt;
    },
  },
};
methods: {
}
</script>
